export default __webpack_public_path__ + "img/list5.d70175ce.jpg";